import { Component, OnInit, ViewChild, ElementRef, signal, AfterViewInit, WritableSignal } from "@angular/core";
import { Table } from 'primeng/table';
import { BreadcrumbService } from '../../app.breadcrumb.service';

import { RequisitionMin } from '../../entites/requisition-min';
import { MenuItem } from 'primeng/api/menuitem';
import { MessageService, ConfirmationService, FilterService } from 'primeng/api';

import { DialogService } from 'primeng/dynamicdialog';
import { ItemMin } from '../../entites/item-min';
import { ItemService } from '../../services/item-service';
import { Router, ActivatedRoute } from '@angular/router';
import { Statut } from 'src/app/entites/statut';
import { CategorieMin } from 'src/app/entites/categorie';
import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { SousCategorieEntite } from 'src/app/entites/sousCategorie';
import { Emplacement } from 'src/app/entites/emplacement';
import { Item } from 'src/app/entites/item';
import { ProfilService } from 'src/app/services/profil-service';
import { AppMainComponent } from 'src/app/app.main.component';
import { CompagnieEntite } from 'src/app/entites/compagnie';
import { LocalisationEntrepotEntite } from 'src/app/entites/localisation-entrepot';
import { TypeFacturationEntite } from 'src/app/entites/type-facturation';
import { RapportService } from 'src/app/services/rapport-service';
import { AttributEntite } from 'src/app/entites/attribut';
import { EStatuts } from 'src/app/entites/enums/statuts';
import { EStatutsSpeciaux } from 'src/app/entites/enums/statuts-speciaux';
import { ContexteService } from 'src/app/services/contexte-service';
import { CreationPieceComponent, ResultatCreationPiece } from 'src/app/controles/mecanique/creation-piece.component';
import { ContextMenu } from 'primeng/contextmenu';
import { AjoutUniteMecaniqueComponent } from 'src/app/controles/mecanique/ajout-unite-mecanique.component';
import { MultiSelect } from "primeng/multiselect";
import { FilterConfig, FiltresAvances } from './controles/filtres-avances.component';
import { HttpEvent, HttpEventType } from "@angular/common/http";
import { SignalWithWatcher } from 'src/app/services/base.service';
import { ETypeChampAttribut, getTypeChamp } from 'src/app/entites/enums/type-champ';
import { AjoutEmpruntsComponent } from "../emprunts/ajout-emprunts.component";
import { RequisitionService } from "src/app/services/requisition-service";
import { SelectionRetourComponent } from "../../controles/selection-retour.component";
import { CreationRetourComponent } from "../../controles/creation-retour.component";
import { Requisition } from "src/app/entites/requisition";
import { Emprunt } from "src/app/entites/emprunt";
import { EmpruntService } from "src/app/services/emprunt.service";
import { SelectionEmplacementComponent } from "src/app/controles/selection-emplacement.component";
import { DocumentEntite } from "src/app/entites/document";
import { DocumentService } from "src/app/services/document-service";

@Component({
    templateUrl: './items.component.html',
    styleUrls: ['./items.component.scss'],
    providers: [MessageService, DialogService]
})
export class ItemsComponent extends BaseComponent implements OnInit, AfterViewInit {

    items: SignalWithWatcher<ItemMin[]>;
    selectedItems: ItemMin[] = [];

    detailItemId: number;
    afficherDetailItem: boolean = false;

    attributs: AttributEntite[];

    filtreCategories: string[];
    filtreSousCategories: string[];
    filtreCompagnies: string[];
    filtreEmplacement: string[];

    retoursActifs: RequisitionMin[] = [];

    statuts: Statut[] = this.sdb.Statuts();

    tableParams = this.createTableFilter();

    dialogueNouvelItem = false;
    submitted = false;
    nouvelItem: Item;
    listeCategories: CategorieMin[];
    listeSousCategoriesComplet: SousCategorieEntite[];
    listeSousCategories: SousCategorieEntite[];
    assignations: string[];
    selectionAssignations: string[];
    listeCompagnies: CompagnieEntite[];
    listeLocalisations: LocalisationEntrepotEntite[];
    listeTypesFacturation: TypeFacturationEntite[];

    descriptions: string[];
    suggestionDescription: string[];

    marques: string[];
    suggestionMarque: string[];

    globalFilter: string = '';

    loadingNouvelItem: boolean = false;

    contenuMenuContextuelAjout: MenuItem[];
    @ViewChild('menuContextuelAjout') menuContextuelAjout: ContextMenu;
    contenuMenuContextuelItem: MenuItem[];
    @ViewChild('menuContextuelItem') menuContextuelItem: ContextMenu;
    contenuMenuSection: MenuItem[] = [
        {
            label: 'Marquer comme complet',
            icon: 'pi pi-check',
            command: () => this.marquerCompletSelection()
        },
        {
            label: 'Produire rapport excel',
            icon: 'pi pi-file-excel',
            command: () => this.exportExcel()
        }
    ];
    @ViewChild('menuContextuelActions') menuContextuelActions: ContextMenu;


    @ViewChild('rechercheItem') inputRechercheItem;
    @ViewChild('descriptionNouvelItem') champDescriptionNouvelItem: ElementRef;
    @ViewChild('champDescription') champDescription;
    @ViewChild('champNumero') champNumero;
    @ViewChild('dt') tableItems: Table;
    @ViewChild('categorie') categorie: MultiSelect;

    statutId: number = null;

    contientItemsIncomplets: boolean = false;

    activerPagination: boolean = true;

    afficherFiltresAvances: boolean = false;

    filterConfigs: FilterConfig[] = [
        {
            key: 'filtreProduitDangereux',
            label: 'Produit dangereux',
            type: 'selectButton',
            field: 'produitDangereux',
            defaultValue: null,
            options: [
                { label: 'Tous', value: null },
                { label: 'Oui', value: true },
                { label: 'Non', value: false }
            ]
        }
    ];

    filtres: FiltresAvances = {
        filtreProduitDangereux: null
    };

    loadingEvent: WritableSignal<HttpEvent<any>> = signal(null);
    loadingError: WritableSignal<string> = signal(null);

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute,
        appMain: AppMainComponent,
        private breadcrumbService: BreadcrumbService,
        private requisitionService: RequisitionService,
        private ItemsService: ItemService,
        private contexteService: ContexteService,
        private messageService: MessageService,
        public rapportService: RapportService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        private empruntService: EmpruntService,
        public routerService: Router,
        private documentService: DocumentService,
        private filterService: FilterService) {
        super(sdb, profilService, route, routerService, appMain);

        // Register custom filter for assignation that checks if any selected value is contained in the field
        this.filterService.register('assignationContains', (value: string, filter: string[]): boolean => {
            if (!filter || filter.length === 0) return true;
            if (!value) return false;
            return filter.some(f => value.includes(f));
        });

        this.route.data.subscribe(x => {

            this.DemarrerChargement();
            if (x.statutId && !isNaN(+x.statutId)) {
                this.statutId = x.statutId;
            }

            this.ItemsService.ObtenirItems(this.statutId, null, (data: ItemMin[]) => {
                return data.map(item => {
                    // Build assignation string for filtering - includes employee name AND their current emplacement
                    let assignation = item.employe
                        ? item.employe.prenom + ' ' + item.employe.nom
                        : item.emplacement?.nom;

                    // Add employee's current emplacement to assignation for filtering purposes
                    if (item.employe && item.emplacementCourantEmploye?.nom) {
                        assignation += '|' + item.emplacementCourantEmploye.nom;
                    }

                    return {
                        ...item,
                        assignation,
                        ...item.valeursAttributs?.reduce((acc, val, index) => ({
                            ...acc,
                            ['att' + val.attribut.attributId]: val.valeur
                        }), {}) || {}
                    };
                });
            }).subscribe({
                next: (x) => {
                    if (x.type == HttpEventType.Response) {
                        this.items = x.body;
                        this.CompleterChargement();
                    }
                    this.loadingEvent.set(x);
                },
                error: (error) => {
                    this.loadingError.set(error.error);
                }
            });

            this.breadcrumbService.setItems([
                { label: x.statutId == EStatutsSpeciaux.PiecesMecanique ? 'Pièces' : x.statutId == EStatutsSpeciaux.UnitesMecanique ? 'Unités' : 'Items' }
            ]);

            if (this.statutId == EStatutsSpeciaux.UnitesMecanique) {
                this.activerPagination = false;
            }
        });
    }

    emplacementCharge = true;

    async ngOnInit() {
        this.verifierAccesPage('items');

        this.attributs = this.sdb.Attributs();

        if (this.profilService.Profil().roles.filter(x => x.nom == 'SIHC_ContremaitreMecanique').length > 0) {
            this.colonnesDisponibles = [
                { base: true, champ: 'categorie', entete: 'Catégorie', afficheParDefaut: true },
                { base: true, champ: 'sousCategorie', entete: 'Sous-catégorie', afficheParDefaut: true },
                { base: true, champ: 'marque', entete: 'Marque', afficheParDefaut: true },
                { base: true, champ: 'modele', entete: 'Modèle', afficheParDefaut: true },
                { base: true, champ: 'noProduit', entete: 'No pièce fournisseur', afficheParDefaut: true },
                { base: true, champ: 'noCtrl', entete: 'No Ctrl', afficheParDefaut: false },
                { base: true, champ: 'assignation', entete: 'Assigné à', afficheParDefaut: true },
                { base: true, champ: 'compagnie', entete: 'Compagnie', afficheParDefaut: false }
            ];
        } else {
            this.colonnesDisponibles = [
                { base: true, champ: 'categorie', entete: 'Catégorie', afficheParDefaut: true },
                { base: true, champ: 'sousCategorie', entete: 'Sous-catégorie', afficheParDefaut: true },
                { base: true, champ: 'marque', entete: 'Marque', afficheParDefaut: true },
                { base: true, champ: 'modele', entete: 'Modèle', afficheParDefaut: true },
                { base: true, champ: 'noProduit', entete: 'No pièce fournisseur', afficheParDefaut: false },
                { base: true, champ: 'noCtrl', entete: 'No Ctrl', afficheParDefaut: false },
                { base: true, champ: 'assignation', entete: 'Assigné à', afficheParDefaut: true },
                { base: true, champ: 'compagnie', entete: 'Compagnie', afficheParDefaut: false }
            ];
        }


        this.attributs.forEach(att => {
            this.colonnesDisponibles.push({
                base: false,
                champ: 'att' + att.attributId,
                entete: att.nom,
                afficheParDefaut: false,
                type: att.typeChamp
            });
        });

        this.colonnesSelectionnees = this.colonnesDisponibles.filter(x => x.afficheParDefaut);

        this.listeCategories = this.sdb.Categories();
        this.filtreCategories = [];
        this.listeCategories.forEach(x => {
            this.filtreCategories.push(x.nom);
        });

        this.requisitionService.ObtenirRetoursActifs().then(x => {
            this.retoursActifs = x.valeur;
        });

        this.listeSousCategoriesComplet = this.sdb.SousCategories();
        this.listeSousCategories = this.listeSousCategoriesComplet;
        this.filtreSousCategories = [];
        this.listeSousCategories.forEach(x => {
            this.filtreSousCategories.push(x.nom);
        });


        this.assignations = this.sdb.Employes().map(x => x.prenom + ' ' + x.nom).concat(this.sdb.Emplacements().map(x => x.nom));

        this.marques = this.sdb.Marques();

        this.listeCompagnies = this.sdb.Compagnies();
        this.filtreCompagnies = [];
        this.listeCompagnies.forEach(x => {
            this.filtreCompagnies.push(x.nom);
        });

        this.listeLocalisations = this.sdb.LocalisationsEntrepot();
        this.listeTypesFacturation = this.sdb.TypesFacturation();
    }

    ngAfterViewInit() {
        this.globalFilter = this.tableParams.getValue().globalFilter;
        this.chargerColonnesSelectionnees();
    }

    clearFilters(table: Table) {
        table.reset();
        table.clear();
        this.globalFilter = '';
        table.sort({
            field: "numero",
            order: 1
        });
        this.filtres = {
            filtreProduitDangereux: null
        };
        this.tableParams.setValue(table);
    }

    ObtenirIdEmplacements(value: Emplacement[]) {
        var temp = [];
        value.forEach(x => temp.push(x.emplacementId));
        return temp;
    }

    /**
     * Custom filter handler for assignation column.
     * Filters items where assignation contains any of the selected values.
     * This allows filtering by emplacement to also find items assigned to employees currently at that emplacement.
     */
    filtrerAssignation(selectedValues: string[], filterCallback: Function) {
        if (!selectedValues || selectedValues.length === 0) {
            filterCallback(null);
        } else {
            filterCallback(selectedValues);
        }
    }

    rechercherMarque(event) {
        this.suggestionMarque = this.marques.filter(x => this.nouvelItem.marque.localeCompare(x.substring(0, this.nouvelItem.marque.length), 'en', { sensitivity: 'base' }) == 0);
    }

    surChangementSousCategorie(event) {

    }

    surFermetureSousCategorie(event) {
        if (this.nouvelItem.sousCategorie && this.nouvelItem.sousCategorie.prefixe) {
            this.Bloquer();

            this.ItemsService.ObtenirProchainNumero(this.nouvelItem.sousCategorie.prefixe).then(x => {
                this.Debloquer()
                this.nouvelItem.numero = this.nouvelItem.sousCategorie.prefixe + x.valeur;


                setTimeout(() => { this.champDescription.focusInput(); }, 100);
            });

        } else {
            setTimeout(() => { this.champNumero.nativeElement.focus(); }, 100);
        }
    }

    surEntreeRecherche() {

        if (this.items.value() && this.items.value().length == 1) {
            this.OuvrirDetailItem(this.items.value()[0].itemId);
        } else {
            this.items.value().forEach(x => {
                if (x.numero == this.globalFilter) {
                    this.OuvrirDetailItem(x.itemId);
                }
            });
        }

    }

    ItemsNonComplets(event: Event) {
        this.confirmationService.confirm({
            key: "itemsnc",
            target: event.target,
            message: 'Il y a des items à compléter. Voulez-vous voir la liste maintenant?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.routerService.navigateByUrl('items/15');
            },
            reject: () => {
                //reject action
            }
        });
    }

    OuvrirDetailItem(itemId: number) {

        if (this.statutId && this.statutId == EStatutsSpeciaux.UnitesMecanique) {
            this.contexteService.Ajouter("tab", "7");
            this.contexteService.Ajouter("origine", "U");
        }
        else if (this.statutId && this.statutId == EStatutsSpeciaux.PiecesMecanique) {
            this.contexteService.Ajouter("origine", "P");
        }
        else {
            this.contexteService.Ajouter("origine", "I");
        }
        this.routerService.navigateByUrl(`item/${itemId}`)
    }

    OuvrirDetailItemNouvelOnglet(itemId: number) {
        this.detailItemId = itemId;
        this.afficherDetailItem = true;
    }

    surBoutonAjout(event) {

        if (this.statutId == EStatutsSpeciaux.PiecesMecanique) {

            this.AjouterPiece();

        } else if (this.statutId == EStatutsSpeciaux.UnitesMecanique) {

            const ref = this.dialogService.open(AjoutUniteMecaniqueComponent, {
                header: 'Ajouter une unité',
                width: '90%'
            }).onClose.subscribe((item: Item) => {
                if (item) {
                    this.contexteService.Ajouter("tab", "7");
                    this.routerService.navigateByUrl('item/' + item.itemId);
                }


            });

        } else {

            this.contenuMenuContextuelAjout = [];

            this.listeCategories.forEach(c => {
                this.contenuMenuContextuelAjout.push({
                    label: c.nom,
                    icon: 'pi pi-fw pi-tag',
                    command: () => this.AjouterItem(c),
                    description: c.description
                })
            });

            this.menuContextuelAjout.toggle(event);


        }
    }

    AjouterItem(c: CategorieMin) {
        if (c.categorieId == 6) {
            this.AjouterPiece();
        } else {
            this.nouvelItem = {
                categorie: c,
                emplacement: this.sdb.Emplacement(10000) // TODO : Hard-code : 10000
            };
            if (this.listeCompagnies.length == 1) {
                this.nouvelItem.compagnie = this.listeCompagnies[0];
            }
            this.dialogueNouvelItem = true;
        }

    }

    AjouterPiece() {
        const ref = this.dialogService.open(CreationPieceComponent, {
            data: {
            },
            header: 'Ajout d\'une pièce mécanique',
            width: '90%'
        }).onClose.subscribe((res: ResultatCreationPiece) => {
            if (res) {
                this.naviguer('item/' + res.item.itemId);
            }
        });
    }

    surMenuContextuelItem(event, item: ItemMin) {
        this.contenuMenuContextuelItem = this.ItemsService.getItemActions(item);
        this.menuContextuelItem.toggle(event);
    }

    emprunter(item: ItemMin) {
        this.dialogService.open(AjoutEmpruntsComponent, {
            data: {
                item: item,
                employe: this.profilService.ProfilCourant()
            },
            header: 'Emprunter',
            width: this.LargeurDialogue
        });
    }

    async retourner(item: ItemMin) {

        var retours: RequisitionMin[] = [];

        if (item.employe) {
            this.retournerEmprunt(item);
            return;
        }

        if (item.emplacement) {
            var x = await this.requisitionService.ObtenirRetoursActifs();
            retours = x.valeur.filter(x => x.de.emplacementId == item.emplacement.emplacementId)
        }

        if (retours.length > 0) {
            const ref = this.dialogService.open(SelectionRetourComponent, {
                data: {
                    retours: retours
                },
                header: 'Sélectionner le retour',
                width: '85%'
            }).onClose.subscribe((res: RequisitionMin) => {
                if (res) {
                    if (res.requisitionId == 0) {
                        const ref = this.dialogService.open(CreationRetourComponent, {
                            data: {
                                emplacementId: item.emplacement.emplacementId
                            },
                            header: 'Créer un nouveau retour',
                            width: '85%'
                        }).onClose.subscribe((resCreationRetour: Requisition) => {
                            if (resCreationRetour) {
                                this.retoursActifs.push(this.requisitionService.RequisitionVersRequisitionMin(resCreationRetour));
                                this.CreerItemRetour(item, this.requisitionService.RequisitionVersRequisitionMin(resCreationRetour))
                            }
                        });
                    } else {
                        this.CreerItemRetour(item, res);
                    }
                }
            });
        } else {
            const ref = this.dialogService.open(CreationRetourComponent, {
                data: {
                    emplacementId: item.emplacement.emplacementId
                },
                header: 'Créer un nouveau retour',
                width: '85%'
            }).onClose.subscribe((resCreationRetour: Requisition) => {
                if (resCreationRetour) {
                    var reqMin = this.requisitionService.RequisitionVersRequisitionMin(resCreationRetour);
                    this.retoursActifs.push(this.requisitionService.RequisitionVersRequisitionMin(resCreationRetour));
                    this.CreerItemRetour(item, this.requisitionService.RequisitionVersRequisitionMin(resCreationRetour))
                }
            });
        }
    }

    retournerEmprunt(item: ItemMin) {
        this.empruntService.getActiveEmpruntForItem(item.itemId).subscribe((emprunt: Emprunt) => {
            if (emprunt) {
                const confirmationAction = () => {
                    this.confirmationService.confirm({
                        message: `Êtes-vous sûr de vouloir effectuer un retour de cet emprunt à l'emplacement ${emprunt.emplacementRetour?.nom}?`,
                        header: 'Confirmation de retour manuel',
                        icon: 'pi pi-info-circle',
                        accept: () => {
                            this.routerService.navigate(['/emprunt/retour', emprunt.empruntId], {
                                queryParams: {
                                    EmplacementId: emprunt.emplacementRetourId
                                }
                            });
                        }
                    });
                };

                if (emprunt.emplacementRetour) {
                    confirmationAction();
                } else {
                    this.dialogService.open(SelectionEmplacementComponent, {
                        header: 'Sélectionner un emplacement de retour',
                        width: '50%'
                    }).onClose.subscribe((result: Emplacement) => {
                        if (result) {
                            emprunt.emplacementRetour = result;
                            emprunt.emplacementRetourId = result.emplacementId;
                            confirmationAction();
                        }
                    });
                }
            }
        });
    }

    CreerItemRetour(item: ItemMin, retour: RequisitionMin) {

        this.Bloquer();

        this.requisitionService.CreerItemRequisition({
            itemsRequisition: [{
                itemRequisitionId: 0,
                requisitionId: retour.requisitionId,
                item: item,
                statut: this.sdb.Statut(EStatuts.Actif),
                employe: this.profilService.ProfilCourant(),
                quantite: 1,
                expediteur: null,
                demandeur: null
            }]
        })

        item.emplacement = this.sdb.Emplacement(10000);

        this.Debloquer();

        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Retour effectué.' });
    }

    onChangeCategorie(event, filter) {
        if (event && event.length > 0) {
            // Update sous-categories filter based on selected categories
            const categoryIds = event;
            this.filtreSousCategories = this.listeSousCategoriesComplet
                .filter(x => categoryIds.includes(x.categorieId))
                .map(x => x.nom);
            // Apply the filter using the callback
            filter(event);
        } else {
            // Reset filters when no categories are selected
            this.filtreSousCategories = this.listeSousCategoriesComplet.map(x => x.nom);
            filter(null);
        }
    }


    dupliquer(item: ItemMin) {
        if (item.categorie.categorieId == 6) {

            const ref = this.dialogService.open(CreationPieceComponent, {
                data: {
                    description: item.description,
                    marque: item.marque,
                    modele: item.modele
                },
                header: 'Ajout d\'une pièce mécanique',
                width: '90%'
            }).onClose.subscribe((res: ResultatCreationPiece) => {
                if (res) {
                    this.naviguer('item/' + res.item.itemId);
                }
            });
        } else {
            this.nouvelItem = {
                categorie: item.categorie,
                description: item.description,
                marque: item.marque,
                modele: item.modele,
                emplacement: this.sdb.Emplacement(10000) // TODO : Hard-code : 10000
            };
            // if (item.sousCategorie) {
            //     this.nouvelItem.sousCategorie = this.listeSousCategories.find(x => x.sousCategorieId = item.sousCategorie.sousCategorieId);
            // }
            if (item.localisation) {
                this.nouvelItem.localisation = this.listeLocalisations.find(x => x.localisationEntrepotEntiteId = item.localisation.localisationEntrepotEntiteId);
            }
            this.dialogueNouvelItem = true;
        }
    }

    dupliquerSelection() {
        if (this.selectedItems && this.selectedItems.length > 0) {
            this.confirmationService.confirm({
                message: `Voulez-vous vraiment dupliquer les ${this.selectedItems.length} items sélectionnés?`,
                accept: () => {
                    // For now, just duplicate the first selected item as an example
                    // In a real implementation, you might want to handle this differently
                    this.dupliquer(this.selectedItems[0]);
                }
            });
        } else {
            this.messageService.add({ severity: 'warn', summary: 'Attention', detail: 'Veuillez sélectionner au moins un item.' });
        }
    }

    marquerComplet(item: ItemMin) {
        this.ItemsService.ModifierStatut(item.itemId, EStatuts.Actif).then(res => {
            if (res) {
                item.statut = this.sdb.Statut(EStatuts.Actif);
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'L\'item a été complété.' });
            } else {
                res.messages.forEach(x => {
                    this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description, sticky: true });
                });
            }
        });
    }

    marquerCompletSelection() {
        if (this.selectedItems && this.selectedItems.length > 0) {
            this.confirmationService.confirm({
                message: `Voulez-vous vraiment marquer les ${this.selectedItems.length} items sélectionnés comme complets?`,
                accept: () => {
                    const promises = this.selectedItems.map(item =>
                        this.ItemsService.ModifierStatut(item.itemId, EStatuts.Actif)
                    );

                    Promise.all(promises).then(results => {
                        const success = results.filter(r => r).length;
                        const failed = results.filter(r => !r).length;

                        if (success > 0) {
                            this.messageService.add({
                                severity: 'success',
                                summary: 'Succès',
                                detail: `${success} item(s) ont été marqués comme complets.`
                            });
                        }

                        if (failed > 0) {
                            this.messageService.add({
                                severity: 'warn',
                                summary: 'Attention',
                                detail: `${failed} item(s) n'ont pas pu être marqués comme complets.`
                            });
                        }
                    });
                }
            });
        } else {
            this.messageService.add({ severity: 'warn', summary: 'Attention', detail: 'Veuillez sélectionner au moins un item.' });
        }
    }

    obtenirProchainNumero() {

        if (this.nouvelItem.numero.length > 0) {
            this.ItemsService.ObtenirProchainNumero(this.nouvelItem.numero).then(x => {
                this.nouvelItem.numero = this.nouvelItem.numero + x.valeur;
            });
        }
    }

    creerNouvelItem() {

        this.loadingNouvelItem = true;
        this.submitted = true;
        this.messageService.clear("nouvelItem");

        if (this.validerNouvelItem()) {

            this.ItemsService.CreerItem(this.nouvelItem).then(x => {
                if (x.estUnSucces) {
                    this.loadingNouvelItem = false;
                    this.routerService.navigateByUrl('item/' + x.valeur.itemId);
                } else {
                    this.loadingNouvelItem = false;
                    x.messages.forEach(x => {
                        this.messageService.add({ key: "nouvelItem", severity: 'error', summary: 'Erreur', detail: x.description, sticky: true });
                    });

                }

            }).catch(error => {
                this.loadingNouvelItem = false;
                this.messageService.add({ key: "nouvelItem", severity: 'error', summary: 'Erreur', detail: error.message, sticky: true });
            });
        } else {
            this.loadingNouvelItem = false;
        }

    }

    validerNouvelItem(): boolean {


        if (!this.nouvelItem.categorie) {
            return false;
        }

        if ((this.nouvelItem.produitDangereux === null || this.nouvelItem.produitDangereux === undefined) && this.nouvelItem.categorie.categorieId == 3) {
            return false;
        }

        if (this.nouvelItem.categorie.estUnique &&
            (!this.nouvelItem.numero || !this.nouvelItem.description || !this.nouvelItem.emplacement || !this.nouvelItem.compagnie)) {
            return false;
        }

        return true;
    }

    annulerNouvelItem() {
        this.dialogueNouvelItem = false;
    }


    obtenirValeurAttribut(item: Item, attributId: string): string {
        var attId = Number(attributId.replace('att', ''));
        var att = item.valeursAttributs.find(x => x.attribut.attributId == attId);
        if (att) {
            return att.valeur;
        } else {
            return '';
        }

    }

    surMenuContextuelActions(event) {
        this.menuContextuelActions.toggle(event);
    }

    exportExcel() {
        var t = this.tableItems.selection;

        var lignes: any[] = t.map(x => ({
            Numéro: x.numero,
            Description: x.description,
            Statut: x.statut.nom
        }));

        for (let index = 0; index < lignes.length; index++) {
            if (this.colonnesSelectionnees.filter(x => x.champ == 'categorie').length == 1) {
                if (t[index].categorie && t[index].categorie.nom) {
                    lignes[index].Categorie = t[index].categorie?.nom;
                } else {
                    lignes[index].Categorie = '';
                }
            }
            if (this.colonnesSelectionnees.filter(x => x.champ == 'sousCategorie').length == 1) {
                if (t[index].sousCategorie && t[index].sousCategorie.nom) {
                    lignes[index].SousCategorie = t[index].sousCategorie?.nom;
                } else {
                    lignes[index].SousCategorie = '';
                }
            }
            if (this.colonnesSelectionnees.filter(x => x.champ == 'marque').length == 1) {
                if (t[index].marque) {
                    lignes[index].Marque = t[index].marque;
                } else {
                    lignes[index].Marque = '';
                }
            }
            if (this.colonnesSelectionnees.filter(x => x.champ == 'modele').length == 1) {
                if (t[index].modele) {
                    lignes[index].Modele = t[index].modele;
                } else {
                    lignes[index].Modele = '';
                }
            }
            if (this.colonnesSelectionnees.filter(x => x.champ == 'noCtrl').length == 1) {
                if (t[index].noCtrl) {
                    lignes[index].NoCtrl = t[index].noCtrl;
                } else {
                    lignes[index].NoCtrl = '';
                }
            }
            if (this.colonnesSelectionnees.filter(x => x.champ == 'assignation').length == 1) {
                if ((t[index].emplacement && t[index].emplacement.nom) || (t[index].employe && t[index].employe?.nom && t[index].employe?.prenom)) {
                    lignes[index].Emplacement = t[index].emplacement ? t[index].emplacement?.nom : `${t[index].employe?.prenom} ${t[index].employe?.nom}`;
                } else {
                    lignes[index].Emplacement = '';
                }
            }
            if (this.colonnesSelectionnees.filter(x => x.champ == 'compagnie').length == 1) {
                if (t[index].compagnie && t[index].compagnie.nom) {
                    lignes[index].Compagnie = t[index].compagnie?.nom;
                } else {
                    lignes[index].Compagnie = '';
                }
            }

            this.attributs.forEach(att => {

                if (this.colonnesSelectionnees.filter(x => x.champ == 'att' + att.attributId).length == 1) {

                    var a = t[index].valeursAttributs.find(x => x.attribut.attributId == att.attributId);

                    if (a) {
                        lignes[index][att.nom] = a.valeur;
                    } else {
                        lignes[index][att.nom] = '';
                    }
                }
            });

        }



        this.messageService.add({ severity: 'info', summary: 'Demande de rapport', detail: `Votre demande de rapport a été envoyée.` });

        this.rapportService.ProduireRapportExcel({
            contenu: JSON.stringify(lignes)
        }).then(x => {
            if (x) {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Votre rapport a été généré.` });
            } else {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: `Une erreur est survenue pendant la génération de votre rapport.` });
            }
        });


    }

    loadPreviewImage(doc: DocumentEntite) {
        if (!doc.previewUrl) {
            if (doc.indCloudflare) {
                this.documentService.ObtenirApercuCloudflare(doc.cheminFichier).subscribe({
                    next: res => {
                        if (res.type === HttpEventType.Response) {
                            doc.previewUrl = URL.createObjectURL(res.body);
                        }
                    }
                });
            }
        }
    }

    obtenirTypeChamp(type: ETypeChampAttribut): string {
        return getTypeChamp(type);
    }


    reinitialiserFiltres() {
        this.filtres = {
            filtreProduitDangereux: null
        };
    }

    get ETypeChampAttribut(): typeof ETypeChampAttribut {
        return ETypeChampAttribut;
    }
}